var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"list"},_vm._l((_vm.getList()),function(value,index){return _c('li',{key:index,staticClass:"item",class:("is-" + index),domProps:{"innerHTML":_vm._s(_vm.convertLinkified(value))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }